/**
 * ╔══════════════════════════════════════════════════════════════════╗
 * ║  HERCULES — Blog Detay Sayfası JS                              ║
 * ║  Dosya: assets/hercules-article.js                             ║
 * ║                                                                  ║
 * ║  Görevler:                                                       ║
 * ║  1. Scroll-reveal (IntersectionObserver)                        ║
 * ║  2. Okuma ilerleme çubuğu                                       ║
 * ║  3. URL kopyalama butonu + toast bildirimi                      ║
 * ║  4. Shopify Theme Editor desteği (section:load)                 ║
 * ╚══════════════════════════════════════════════════════════════════╝
 */

(function () {
  "use strict";

  /* ─── Utility ────────────────────────────────────────────────────── */
  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }
  function qsa(sel, ctx) {
    return Array.from((ctx || document).querySelectorAll(sel));
  }

  /* ─── 1. Scroll Reveal ───────────────────────────────────────────── */
  function initReveal() {
    var els = qsa(".ha-reveal");
    if (!els.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" },
    );

    els.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ─── 2. Okuma İlerleme Çubuğu ───────────────────────────────────── */
  function initProgress() {
    var bar = qs("#ha-read-progress");
    var content = qs("#ha-article-content");
    if (!bar || !content) return;

    function update() {
      var rect = content.getBoundingClientRect();
      var total = content.offsetHeight - window.innerHeight;
      var scrolled = -rect.top;
      var pct = Math.min(100, Math.max(0, (scrolled / total) * 100));
      bar.style.height = pct + "%";
    }

    window.addEventListener("scroll", update, { passive: true });
    update();
  }

  /* ─── 3. URL Kopyalama + Toast ───────────────────────────────────── */
  function initCopy() {
    var btns = qsa(".ha-copy-btn");
    if (!btns.length) return;

    /* Toast elemanı oluştur */
    var toast = document.createElement("div");
    toast.className = "ha-toast";
    toast.setAttribute("role", "status");
    toast.setAttribute("aria-live", "polite");
    toast.textContent = window.hrcI18n?.linkCopied || "Link copied!";
    document.body.appendChild(toast);

    var toastTimer;

    function showToast() {
      clearTimeout(toastTimer);
      toast.classList.add("is-visible");
      toastTimer = setTimeout(function () {
        toast.classList.remove("is-visible");
      }, 2400);
    }

    btns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var url = btn.getAttribute("data-copy-url") || window.location.href;

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(showToast).catch(fallback);
        } else {
          fallback();
        }

        function fallback() {
          var ta = document.createElement("textarea");
          ta.value = url;
          ta.style.cssText = "position:fixed;opacity:0;pointer-events:none;";
          document.body.appendChild(ta);
          ta.focus();
          ta.select();
          try {
            document.execCommand("copy");
            showToast();
          } catch (e) {}
          document.body.removeChild(ta);
        }
      });
    });
  }

  /* ─── 4. Başlatıcı ───────────────────────────────────────────────── */
  function init() {
    initReveal();
    initProgress();
    initCopy();
  }

  /* ─── 5. Shopify Theme Editor ────────────────────────────────────── */
  document.addEventListener("shopify:section:load", function (e) {
    if (e.target.querySelector(".ha-page")) {
      init();
    }
  });

  /* ─── Çalıştır ───────────────────────────────────────────────────── */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
